<template>
  <div class="info-row">
    <slot/>
  </div>
</template>
<script lang="ts">
import {Component, Vue, toNative} from 'vue-facing-decorator'

/**
 * A faixa de campos abaixo do cabeçalho de uma tela de design: nome, alias e o que mais
 * a tela mostre lado a lado.
 *
 * Existe porque as três telas de design escreviam a mesma faixa à mão, e da pior forma:
 * uma `v-row no-gutters` com `ml-0 mr-10` em cada coluna — o `ml-0` é no-op, e o `mr-10`
 * são 40px fixos que não encolhem no telefone. Desligar a gutter da grade para recolocar
 * o vão à mão é mistura de dois sistemas de espaçamento.
 *
 * Flex com `gap`, como o PageHeader: um número só, os campos quebram para a linha de
 * baixo quando não couberem, e nenhuma tela precisa saber quanto vale o vão.
 */
@Component({name: 'ontos-info-row'})
class InfoRow extends Vue {
}

export default toNative(InfoRow)
</script>
<style scoped>
/* O vão vertical é menor que o horizontal: quando a faixa quebra, as linhas são o mesmo
   bloco de informação e não devem parecer duas seções. */
.info-row {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 24px;
}
</style>

<!-- Sem scoped de propósito: o conteúdo do slot é compilado com o id de escopo de QUEM
     usa a faixa, não com o desta, então uma regra scoped aqui não alcançaria os campos.
     O seletor é preso à própria classe, que só existe neste componente. -->
<style>
/* O ViewInfo é um v-list-item, e o Vuetify dá a ele `flex: 1 1 100%` — numa faixa flex
   isso empurra cada campo para a sua própria linha. Aqui cada um ocupa o que o conteúdo
   pede, que é o papel que o `v-col cols="auto"` fazia antes.

   `div.info-row` e não `.info-row`: contra `.v-list-item` a especificidade empataria, e
   quem venceria dependeria da ordem em que os estilos entram na página. */
div.info-row > * {
  flex: 0 0 auto;
  max-width: 100%;
}
</style>
